import React from "react";
import { Tooltip } from "antd";

const TooltipCustom = ({ title, children }: any) => {
  return (
    <Tooltip
      placement="bottom"
      title={title}
      align={{
        offset: [0, -3],
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipCustom;
